import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Setup from "@/components/landing/Setup";
import Features from "@/components/landing/Features";
import AgentTypes from "@/components/landing/AgentTypes";
import LogoStrip from "@/components/landing/LogoStrip";
import Benchmarks from "@/components/landing/Benchmarks";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

function App() {
    return (
        <div className="App bg-[#050505] text-neutral-100 antialiased">
            <Navbar />
            <main>
                <Hero />
                <HowItWorks />
                <Setup />
                <Features />
                <AgentTypes />
                <LogoStrip />
                <Benchmarks />
                <Testimonials />
                <Faq />
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-center" />
        </div>
    );
}

export default App;
